import styled from 'styled-components'

import grabColor from 'src/utils/grabColor'
import StarIcon from './icons/Star'

function StarRating({ size = 19, className = '', rating }) {
  return (
    <div className={className}>
      {[1, 2, 3, 4, 5].map((star) => {
        const full = rating >= star
        const leftOver = 1 - (star - rating)
        const isRatio = leftOver < 1 && leftOver > 0

        return (
          <StarHolder key={star}>
            {(full || isRatio) && (
              <StarIconOverlay size={size} ratio={isRatio ? leftOver : 0} />
            )}
            <StarIconBase size={size} />
          </StarHolder>
        )
      })}
    </div>
  )
}

const StarIconBase = styled(StarIcon)``
const StarIconCover = styled(StarIcon)`
  position: absolute;
`

function StarIconCoverHolder({ className = '', ...props }) {
  return (
    <div className={className}>
      <StarIconCover {...props} />
    </div>
  )
}

const StarIconOverlay = styled(StarIconCoverHolder)`
  overflow: hidden;
  width: ${({ ratio }) => (ratio ? `${ratio * 100}%` : '100%')};
  height: 100%;
`

const StarRatings = styled(StarRating)`
  display: flex;
  align-items: center;
  gap: 5px;
`

const StarHolder = styled.div`
  position: relative;

  ${StarIconBase} {
    z-index: 10;

    path {
      fill: ${grabColor('accentMid')};
    }
  }

  ${StarIconOverlay} {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 20;

    path {
      fill: ${grabColor('brand.dark')};
    }
  }
`

export default StarRatings
